import { actions, actionTypes } from "@tailormed/common-client/store/action";

const Types = {
  LOGIN_ACTION: "LOGIN_ACTION",
  SET_AUTH: "SET_AUTH",
  SET_ENVIRONMENT: "SET_ENVIRONMENT",
  SET_USER: "SET_USER",
  SET_NETWORK_ACTION: "SET_NETWORK_ACTION",
  SET_IDP_CONFIG: "SET_IDP_CONFIG",
  SET_OKTA_CONFIG: "SET_OKTA_CONFIG",
  SET_IS_PHI_ALLOWED: "SET_IS_PHI_ALLOWED",
  SET_TIER: "SET_TIER",
  SET_SETTINGS: "SET_SETTINGS",
  SET_SHOW_CONTACT_SUPPORT_MODAL: "SET_SHOW_CONTACT_SUPPORT_MODAL",
  SET_TABLEAU_TOKEN: "SET_TABLEAU_TOKEN",
  SET_FILTERS: "SET_FILTERS",
  PROVIDERS_ACTION: "PROVIDERS_ACTION",
  SET_ASSIGNEES: "SET_ASSIGNEES",
  SET_MULTIPLES: "SET_MULTIPLES",
  GET_INSIGHTS_ENROLLMENTS_REPORT_ACTION: "GET_INSIGHTS_ENROLLMENTS_REPORT_ACTION",
  SET_REPORT_DATA: "SET_REPORT_DATA",
  SET_REPORT_COLUMNS: "SET_REPORT_COLUMNS",
  SET_ENROLLMENTS_REPORT_DATA: "SET_ENROLLMENTS_REPORT_DATA",
  GET_ENROLLMENTS_REPORT_DATA: "GET_ENROLLMENTS_REPORT_DATA",
  SET_ENROLLMENT_CLAIMS_REPORT_DATA: "SET_ENROLLMENT_CLAIMS_REPORT_DATA",
  GET_ENROLLMENT_CLAIMS_REPORT_DATA: "GET_ENROLLMENT_CLAIMS_REPORT_DATA",
  SET_CLAIMS_REPORT_DATA: "SET_CLAIMS_REPORT_DATA",
  GET_CLAIMS_REPORT_DATA: "GET_CLAIMS_REPORT_DATA",
  SET_USER_GROUPS: "SET_USER_GROUPS",
  SET_ORDERS_REPORT_DATA: "SET_ORDERS_REPORT_DATA",
  GET_ORDERS_REPORT_DATA: "GET_ORDERS_REPORT_DATA",
  SET_COMPLETED_ORDERS_REPORT_DATA: "SET_COMPLETED_ORDERS_REPORT_DATA",
  GET_COMPLETED_ORDERS_REPORT_DATA: "GET_COMPLETED_ORDERS_REPORT_DATA",
  ...actionTypes
};

const loginAction = (username, password) => ({
  type: Types.LOGIN_ACTION,
  username,
  password
});

const setAuth = (auth) => ({
  type: Types.SET_AUTH,
  auth
});

const setEnvironment = (environment) => ({
  type: Types.SET_ENVIRONMENT,
  environment
});

const setUser = (user) => ({
  type: Types.SET_USER,
  user
});

const setNetworkAction = (actionType, isFetching, msg = "", code = undefined) => ({
  type: Types.SET_NETWORK_ACTION,
  actionType,
  isFetching,
  msg,
  code
});

const setIDPConfig = (idpConfig) => ({
  type: Types.SET_IDP_CONFIG,
  idpConfig
});

const setOktaConfig = (oktaClientId) => ({
  type: Types.SET_OKTA_CONFIG,
  oktaClientId
});

const setIsPhiAllowed = (isPhiAllowed) => ({
  type: Types.SET_IS_PHI_ALLOWED,
  isPhiAllowed
});

const setTier = (tier) => ({
  type: Types.SET_TIER,
  tier
});

const setSettings = (settings) => ({
  type: Types.SET_SETTINGS,
  settings
});

const setShowContactSupportModal = (showContactSupportModal) => ({
  type: Types.SET_SHOW_CONTACT_SUPPORT_MODAL,
  showContactSupportModal
});

const setTableauToken = (tableauToken) => ({
  type: Types.SET_TABLEAU_TOKEN,
  tableauToken
});

const setFilters = (filters) => ({
  type: Types.SET_FILTERS,
  filters
});

const provider = (providers) => ({
  type: Types.PROVIDERS_ACTION,
  providers
});

const setAssignees = (assignees) => ({
  type: Types.SET_ASSIGNEES,
  assignees
});

const setMultiplesFilter = (multiples) => ({
  type: Types.SET_MULTIPLES,
  multiples
});

const getEnrollmentsReportData = (filters) => ({
  type: Types.GET_ENROLLMENTS_REPORT_DATA,
  filters
});

const getClaimsReportData = (filters) => ({
  type: Types.GET_CLAIMS_REPORT_DATA,
  filters
});

const setEnrollmentsReportData = (enrollmentsReportData) => ({
  type: Types.SET_ENROLLMENTS_REPORT_DATA,
  enrollmentsReportData
});

const setEnrollmentClaimsReportData = (enrollmentClaimsReportData) => ({
  type: Types.SET_ENROLLMENT_CLAIMS_REPORT_DATA,
  enrollmentClaimsReportData
});

const getEnrollmentClaimsReportData = (filters) => ({
  type: Types.GET_ENROLLMENT_CLAIMS_REPORT_DATA,
  filters
});

const setClaimsReportData = (claimsReportData) => ({
  type: Types.SET_CLAIMS_REPORT_DATA,
  claimsReportData
});

const setUserGroups = (userGroups) => ({
  type: Types.SET_USER_GROUPS,
  userGroups
});

const setOrdersReportData = (ordersReportData) => ({
  type: Types.SET_ORDERS_REPORT_DATA,
  ordersReportData
});

const getOrdersReportData = (filters) => ({
  type: Types.GET_ORDERS_REPORT_DATA,
  filters
});

const setCompletedOrdersReportData = (completedOrdersReportData) => ({
  type: Types.SET_COMPLETED_ORDERS_REPORT_DATA,
  completedOrdersReportData
});

const getCompletedOrdersReportData = (filters) => ({
  type: Types.GET_COMPLETED_ORDERS_REPORT_DATA,
  filters
});

const setReportsColumns = (reportColumns) => ({
  type: Types.SET_REPORT_COLUMNS,
  reportColumns
});

export default {
  loginAction,
  setAuth,
  setEnvironment,
  setUser,
  setNetworkAction,
  setIDPConfig,
  setOktaConfig,
  setIsPhiAllowed,
  setTier,
  setSettings,
  setShowContactSupportModal,
  Types,
  setTableauToken,
  setFilters,
  provider,
  setAssignees,
  setMultiplesFilter,
  setReportsColumns,
  setEnrollmentsReportData,
  getEnrollmentsReportData,
  setEnrollmentClaimsReportData,
  getEnrollmentClaimsReportData,
  setClaimsReportData,
  getClaimsReportData,
  setUserGroups,
  getOrdersReportData,
  setOrdersReportData,
  getCompletedOrdersReportData,
  setCompletedOrdersReportData,
  ...actions
};
